import { useConfig } from "@agportal/config";
import { merge } from "lodash-es";
import Matomo from "vue-matomo";

export default function install(app, options) {
    const config = useConfig();
    const opts = merge({}, config.$get("tracking"), options, {
        disableCookies: true,
        // set to true to not track users who opt out of tracking using Mozilla's (proposed) Do Not Track setting
        preInitActions: [["setDoNotTrack", true], ["trackPageView"]],
    });

    if (opts.enabled) {
        app.use(Matomo, opts);
    }
}
